import React, { useEffect, useState } from "react";
import { CustomGetAPI, CustomPostAPI } from "../../Utils/APIConnector";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import ResponsivePaginationComponent from "react-responsive-pagination";
import "react-responsive-pagination/themes/classic-light-dark.css";
import {
  formatDateTime,
  venueAmenitiesData,
  VenueDate,
  venueSportsData,
} from "../../Utils/common";
import Loader from "../../Utils/Loader";
import Select from "react-select";

export function RedirectedPage() {
  const initalTab = localStorage.getItem("TabId");
  const [toogleTabs, setToogleTabs] = useState(parseInt(initalTab) || 1);
  const [response, setResponse] = useState([]);
  const [AllCities, setAllCities] = useState([]);
  const [bookingsChoice, setBookingsChoice] = useState("onlineBooking");
  const [lastDaysChoice, setLastDaysChoice] = useState("today");
  const [totalPage, setTotalPage] = useState(0);
  const [loader, setLoader] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentColumn, setCurrentColumn] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [venueType, setVenueType] = useState("0");
  const [cityName, setCityName] = useState("0");

  const [dateRange, setDateRange] = useState({
    fromDate: new Date(),
    toDate: new Date(),
  });

  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem("User_Authenticated");

  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/admin-login");
      return;
    }
    navigate("/admin-stats");
    async function fetchData() {
      setLoader(true);
      const raw = JSON.stringify({
        pageSize: itemsPerPage,
        pageNumber: currentPage,
        sortColumn: currentColumn,
        sortDirection: sortOrder,
        FromDate: toogleTabs !== 2 ? "" : dateRange.fromDate,
        ToDate: toogleTabs !== 2 ? "" : dateRange.toDate,
        isFrom: toogleTabs,
        isForBookingRequest: bookingsChoice === "onlineBooking" ? false : true,
        VenueType: parseInt(venueType),
        CityId: cityName === "0" ? 0 : parseInt(cityName.value),
      });

      try {
        const result = JSON.parse(
          await CustomPostAPI("/AdminStats/GetAdminStats", raw)
        );
        setResponse(result);
        setTotalPage(Math.ceil(result.totalCount / itemsPerPage));
        setLoader(false);
      } catch (err) {
        console.error(err);
        alert("Something went wrong!");
      }
    }

    fetchData();
  }, [
    isLoggedIn,
    navigate,
    toogleTabs,
    currentPage,
    itemsPerPage,
    currentColumn,
    sortOrder,
    dateRange.fromDate,
    dateRange.toDate,
    bookingsChoice,
    venueType,
    cityName,
  ]);

  useEffect(() => {
    async function GetCities() {
      try {
        const result = JSON.parse(await CustomGetAPI("/venue/GetAllCity"));
        if (result.status === "success") {
          setAllCities([
            { value: 0, label: "All" },
            ...result?.cities?.map((item) => ({
              value: item.cityId,
              label: item.cityName,
            })),
          ]);
        }
      } catch (err) {
        console.error(err);
        alert("Something went wrong!");
      }
    }
    // if(toogleTabs === 1) {
    GetCities();
    // }
  }, [isLoggedIn, navigate]);

  const handleTabChange = (tabId) => {
    localStorage.setItem("TabId", tabId);
    setToogleTabs(tabId);
    setCurrentPage(1);
    setCurrentColumn("");
    setSortOrder("asc");
    setCityName("0");
    setVenueType("0");
    setBookingsChoice("onlineBooking");
    setLastDaysChoice("today");
    setDateRange({
      fromDate: new Date(),
      toDate: new Date(),
    });
  };

  const handleSort = (column) => {
    setCurrentColumn(column);
    setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleDateChange = (date, field) => {
    const iso = date ? date : "";
    setDateRange((prev) => ({ ...prev, [field]: iso }));
    setCurrentPage(1);
  };

  const lastDayFunction = (e) => {
    const selectedValue = e.target.value;
    setLastDaysChoice(selectedValue);
    if (selectedValue === "custom") {
      setDateRange({
        fromDate: new Date(new Date().setDate(new Date().getDate() - 30)),
        toDate: new Date(),
      });
    } else {
      const daysMap = {
        today: 0,
        yesterday: 1,
        last7days: 7,
        last15days: 15,
        last30days: 30,
      };
      const days = daysMap[selectedValue];
      const fromDate = new Date(
        new Date().setDate(new Date().getDate() - days)
      );
      setDateRange({
        fromDate: fromDate,
        toDate: selectedValue == "yesterday" ? fromDate : new Date(),
      });
    }
    setCurrentPage(1);
  };

  return (
    <React.Fragment>
      <div className="mx-md-5 mt-4 d-flex flex-column">
        <div className="d-flex flex-md-row flex-column px-0 mb-3 gap-3 justify-content-between">
          <div className="d-flex gap-3">
            <div className="admin-stats-tab-wrapper d-inline-flex">
              <label
                onClick={() => handleTabChange(1)}
                className={`cursor-pointer h-100 ${toogleTabs === 1 ? "admin-stats-tab-label-bg" : ""
                  }`}
              >
                Venues
              </label>
              <label
                onClick={() => handleTabChange(2)}
                className={`cursor-pointer h-100 ${toogleTabs === 2 ? "admin-stats-tab-label-bg" : ""
                  }`}
              >
                Bookings
              </label>
              <label
                onClick={() => handleTabChange(3)}
                className={`cursor-pointer h-100 ${toogleTabs === 3 ? "admin-stats-tab-label-bg" : ""
                  }`}
              >
                Users
              </label>
            </div>
            {toogleTabs === 2 && (
              <>
                <select
                  className="pe-4 ps-2 rounded customize-select p-0 admin-stats-tab-wrapper heading-color bg-white"
                  onChange={(e) => setBookingsChoice(e.target.value)}
                  value={bookingsChoice}
                >
                  <option value="onlineBooking" className="bg-white">
                    Online Booking
                  </option>
                  <option value="bookingRequest" className="bg-white">
                    Booking Request
                  </option>
                </select>
              </>
            )}
          </div>
          {toogleTabs === 2 && (
            <>
              <div className=" d-flex justify-content-end px-0">
                <select
                  className="pe-5 ps-2 rounded customize-select p-0 admin-stats-tab-wrapper heading-color bg-white w-auto mx-2"
                  onChange={(e) => lastDayFunction(e)}
                  value={lastDaysChoice}
                >
                  <option value="today" className="bg-white" data-days="0">
                    Today
                  </option>
                  <option value="yesterday" className="bg-white" data-days="1">
                    Yesterday
                  </option>
                  <option value="last7days" className="bg-white" data-days="7">
                    Last 7 days
                  </option>
                  <option
                    value="last15days"
                    className="bg-white"
                    data-days="15"
                  >
                    Last 15 days
                  </option>
                  <option
                    value="last30days"
                    className="bg-white"
                    data-days="30"
                  >
                    Last 30 days
                  </option>
                  <option value="custom" className="bg-white">
                    Custom
                  </option>
                </select>
                {lastDaysChoice === "custom" && (
                  <>
                    <div
                      className="position-relative mx-2"
                      style={{ width: "25%" }}
                    >
                      <label
                        className="text-nowrap heading-color position-absolute bg-white px-1"
                        style={{
                          zIndex: 1,
                          top: "-12px",
                          left: "12px",
                          fontSize: "13px",
                        }}
                      >
                        From Date:
                      </label>
                      <DatePicker
                        selected={
                          dateRange.fromDate
                            ? new Date(dateRange.fromDate)
                            : new Date(
                              new Date().setDate(new Date().getDate() - 30)
                            )
                        }
                        onChange={(d) => handleDateChange(d, "fromDate")}
                        dateFormat="yyyy-MM-dd"
                        className="form-control admin-stats-datepicker"
                        showIcon
                      />
                    </div>
                    <div
                      className="position-relative mx-2"
                      style={{ width: "25%" }}
                    >
                      <label
                        className="text-nowrap heading-color position-absolute bg-white px-1"
                        style={{
                          zIndex: 1,
                          top: "-12px",
                          left: "12px",
                          fontSize: "13px",
                        }}
                      >
                        To Date:
                      </label>
                      <DatePicker
                        selected={
                          dateRange.toDate
                            ? new Date(dateRange.toDate)
                            : new Date()
                        }
                        onChange={(d) => handleDateChange(d, "toDate")}
                        dateFormat="yyyy-MM-dd"
                        className="form-control admin-stats-datepicker"
                        showIcon
                      />
                    </div>
                  </>
                )}
              </div>
            </>
          )}
          {toogleTabs === 1 && (
            <div className="d-flex align-items-center justify-content-center gap-4 w-25">
              <Select
                value={cityName === "0" ? AllCities[0] : cityName}
                options={AllCities}
                onChange={(selectedCity) => setCityName(selectedCity)}
                isSearchable
                className="customize-select p-0 bg-white h-100 w-50"
              />
              <select
                className="pe-5 ps-2 customize-select p-0 admin-stats-tab-wrapper heading-color bg-white h-100 w-50"
                value={venueType}
                onChange={(e) => setVenueType(e.target.value)}
              >
                <option value="0">All</option>
                <option value="4">Online</option>
                <option value="5">Offline</option>
                <option value="6">Info</option>
              </select>
            </div>
          )}
        </div>
        {loader ? (
          <Loader mt="20%" />
        ) : (
          <>
            {toogleTabs === 1 && (
              <>
                <div className="d-flex flex-wrap gap-5">
                  <label className="venue-listing-labels ">
                    <strong>Total Venues </strong>: {response.totalCount}
                  </label>
                  <label className="venue-listing-labels">
                    <strong>Online Venues </strong> : {response.onlineVenues}
                  </label>
                  <label className="venue-listing-labels">
                    <strong>Offline Venues </strong> : {response.offlineVenues}
                  </label>
                  <label className="venue-listing-labels">
                    <strong>Info Venues </strong> : {response.infoVenues}
                  </label>
                  <label className="venue-listing-labels">
                    <strong>Commission Venues </strong> :{" "}
                    {response.commisionVenues}
                  </label>
                </div>
                <table className="admin-stats-table-spacing px-0">
                  <tbody>
                    <tr className="admin-stats-header">
                      <th className="p-3 text-nowrap table-left-border-radius">
                        Name
                        <img
                          src="/images/arrows-down-up.svg"
                          alt=""
                          className="cursor-pointer ms-2"
                          onClick={() => handleSort("venuename")}
                        />
                      </th>
                      <th className="p-3">Mobile</th>
                      <th className="p-3 text-nowrap">
                        Type
                        <img
                          src="/images/arrows-down-up.svg"
                          alt=""
                          className="cursor-pointer ms-2"
                          onClick={() => handleSort("isactive")}
                        />
                      </th>
                      <th className="p-3 text-nowrap">
                        City
                        <img
                          src="/images/arrows-down-up.svg"
                          alt=""
                          className="cursor-pointer ms-2"
                          onClick={() => handleSort("cityname")}
                        />
                      </th>
                      <th className="p-3 text-nowrap">
                        Created At
                        <img
                          src="/images/arrows-down-up.svg"
                          alt=""
                          className="cursor-pointer ms-2"
                          onClick={() => handleSort("createdat")}
                        />
                      </th>
                      <th className="p-3 text-nowrap table-right-border-radius text-center">
                        Commission
                        <img
                          src="/images/arrows-down-up.svg"
                          alt=""
                          className="cursor-pointer ms-2"
                          onClick={() => handleSort("commission")}
                        />
                      </th>
                    </tr>
                    {response?.listingData?.length !== 0 ? (
                      response?.listingData?.map((item, idx) => (
                        <tr key={idx}>
                          <td className="p-3 table-top-bottom-border table-left-border-radius">
                            {item.venueName || "-"}
                          </td>
                          <td className="p-3 table-top-bottom-border">
                            {item.venueNumber || "-"}
                          </td>
                          <td className="p-3 table-top-bottom-border">
                            {item.isActive === 4
                              ? "Online"
                              : item.isActive === 5
                                ? "Offline"
                                : item.isActive === 6
                                  ? "Info"
                                  : "N/A"}
                          </td>
                          <td className="p-3 table-top-bottom-border">
                            {item.cityName || "-"}
                          </td>
                          <td className="p-3 table-top-bottom-border">
                            {item.createdAt
                              ? formatDateTime(
                                item.createdAt,
                                " DD/MM/YY hh:mm A"
                              )
                              : "-"}
                          </td>
                          <td className="p-3 table-top-bottom-border text-center table-right-border-radius">
                            {item.commission == null
                              ? "0%"
                              : `${item.commission}%`}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr className="heading-color">
                        <td>No Data Found!</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </>
            )}

            {toogleTabs === 2 && (
              <>
                <div className="d-flex flex-wrap gap-5">
                  <label className="venue-listing-labels ">
                    <strong>Overall Bookings </strong>:{" "}
                    {response.overAllRecords}
                  </label>
                  {bookingsChoice === "onlineBooking" ? (
                    <>
                      <label className="venue-listing-labels">
                        <strong>Today's Bookings </strong> :{" "}
                        {response.todaysBooking}
                      </label>
                      <label className="venue-listing-labels">
                        <strong>Yesterday's Bookings </strong> :{" "}
                        {response.yestredaysBooking}
                      </label>
                      <label className="venue-listing-labels">
                        <strong>Last 7 days Bookings </strong> :{" "}
                        {response.last7DaysBooking}
                      </label>
                      <label className="venue-listing-labels">
                        <strong>Last 30 days Bookings </strong> :{" "}
                        {response.last30DaysBooking}
                      </label>
                      <label className="venue-listing-labels">
                        <strong>Before 30 days Bookings </strong> :{" "}
                        {response.before30DaysBooking}
                      </label>
                    </>
                  ) : (
                    <>
                      <label className="venue-listing-labels">
                        <strong>Total Payment Done </strong> :{" "}
                        {response.totalPaymentDone}
                      </label>
                      <label className="venue-listing-labels">
                        <strong>Total Request Accepted </strong> :{" "}
                        {response.totalRequestAccepted}
                      </label>
                    </>
                  )}
                </div>
                <div style={{ overflowX: "auto", width: "100%" }}>
                  <table
                    className="admin-stats-table-spacing px-0"
                    style={{ minWidth: 900 }}
                  >
                    <thead>
                      <tr className="admin-stats-header">
                        <th className="p-3 text-nowrap table-left-border-radius">
                          Booking Date
                          <img
                            src="/images/arrows-down-up.svg"
                            alt=""
                            className="cursor-pointer ms-2"
                            onClick={() => handleSort("paymentCreatedAt")}
                          />
                        </th>
                        <th className="p-3 text-nowrap">
                          Venue Name
                          <img
                            src="/images/arrows-down-up.svg"
                            alt=""
                            className="cursor-pointer ms-2"
                            onClick={() => handleSort("venuename")}
                          />
                        </th>
                        <th className="p-3 text-nowrap">Sport</th>
                        <th className="p-3 text-nowrap">
                          City
                          <img
                            src="/images/arrows-down-up.svg"
                            alt=""
                            className="cursor-pointer ms-2"
                            onClick={() => handleSort("cityname")}
                          />
                        </th>
                        <th className="p-3 text-nowrap">Duration</th>
                        <th className="p-3 text-nowrap">
                          Play Date
                          <img
                            src="/images/arrows-down-up.svg"
                            alt=""
                            className="cursor-pointer ms-2"
                            onClick={() => handleSort("bookingDate")}
                          />
                        </th>
                        <th className="p-3 text-nowrap">Booking Amount</th>
                        <th className="p-3 text-nowrap">Total Amount</th>
                        <th className="p-3 text-nowrap table-right-border-radius">
                          Commission
                          <img
                            src="/images/arrows-down-up.svg"
                            alt=""
                            className="cursor-pointer ms-2"
                            onClick={() => handleSort("commisionAmount")}
                          />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {response?.listingData?.length !== 0 ? (
                        response?.listingData?.map((item, index) => (
                          <tr key={index}>
                            <td className="p-3 table-top-bottom-border table-left-border-radius">
                              {item.paymentCreatedAt
                                ? VenueDate(item.paymentCreatedAt)
                                  ?.formattedDate
                                : "-"}
                            </td>
                            <td className="p-3 table-top-bottom-border">
                              {item.venueName || "-"}
                            </td>
                            <td className="p-3 table-top-bottom-border">
                              <img
                                src={`/images/${venueSportsData(
                                  item.sportName
                                )}`}
                                alt=""
                                height={22}
                                width={22}
                                title={item.sportName}
                              />
                            </td>
                            <td className="p-3 table-top-bottom-border">
                              {item.cityName || "-"}
                            </td>
                            <td className="p-3 table-top-bottom-border">
                              {item.duration || "-"} hrs
                            </td>
                            <td className="p-3 table-top-bottom-border text-nowrap">
                              {item.bookingDate
                                ? formatDateTime(
                                  item.bookingDate.split("T")[0] +
                                  "T" +
                                  item?.bookingTime,
                                  "DD/MM/YY hh:mm A"
                                )
                                : "-"}
                            </td>
                            <td className="p-3 table-top-bottom-border">
                              ₹ {item.bookingAmount?.toFixed(2) || "-"}
                            </td>
                            <td className="p-3 table-top-bottom-border">
                              ₹ {item.totalAmount?.toFixed(2) || "-"}
                            </td>
                            <td className="p-3 table-top-bottom-border table-right-border-radius">
                              ₹ {item?.commisionAmount?.toFixed(2) || "-"} (
                              {item.commissionPercentage}%)
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr className="heading-color">
                          <td>No Data Found!</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </>
            )}
            {/* {toogleTabs === 2 && (
              <table className="admin-stats-table-spacing px-0">
                <tbody>
                  <tr className="admin-stats-header">
                    <th className="p-3 table-left-border-radius">Accepted</th>
                    <th className="p-3 text-nowrap">
                      Venue
                      <img
                        src="/images/arrows-down-up.svg"
                        alt=""
                        className="cursor-pointer ms-2"
                        onClick={() => handleSort("venuename")}
                      />
                    </th>
                    <th className="p-3 text-nowrap">
                      Area
                      <img
                        src="/images/arrows-down-up.svg"
                        alt=""
                        className="cursor-pointer ms-2"
                        onClick={() => handleSort("area")}
                      />
                    </th>
                    <th className="p-3 text-nowrap">
                      City
                      <img
                        src="/images/arrows-down-up.svg"
                        alt=""
                        className="cursor-pointer ms-2"
                        onClick={() => handleSort("cityname")}
                      />
                    </th>
                    <th className="p-3 text-nowrap">
                      Name
                      <img
                        src="/images/arrows-down-up.svg"
                        alt=""
                        className="cursor-pointer ms-2"
                        onClick={() => handleSort("username")}
                      />
                    </th>
                    <th className="p-3">Number</th>
                    <th className="p-3 text-nowrap">
                      Payment Date
                      <img
                        src="/images/arrows-down-up.svg"
                        alt=""
                        className="cursor-pointer ms-2"
                        onClick={() => handleSort("paymentcreatedat")}
                      />
                    </th>
                    <th className="p-3 text-nowrap">
                      Play Date
                      <img
                        src="/images/arrows-down-up.svg"
                        alt=""
                        className="cursor-pointer ms-2"
                        onClick={() => handleSort("bookingdate")}
                      />
                    </th>
                    <th className="col-md-1 p-3 table-right-border-radius">
                      Paid
                    </th>
                  </tr>
                  {response?.listingData?.length !== 0 ? (
                    response?.listingData?.map((item, index) => (
                      <tr key={index}>
                        <td className="p-3 table-top-bottom-border table-left-border-radius">
                          {item.venuePaymentLog === 2 ||
                          item.venuePaymentLog === 4 ||
                          item.venuePaymentLog === 10
                            ? "yes"
                            : "no"}
                          {item.isAccepted ? "yes" : "no"}
                        </td>
                        <td className="p-3 table-top-bottom-border">
                          {item.venueName || "-"}
                        </td>
                        <td className="p-3 table-top-bottom-border">
                          {item.area}
                        </td>
                        <td className="p-3 table-top-bottom-border">
                          {item.cityName || "-"}
                        </td>
                        <td className="p-3 table-top-bottom-border">
                          {item.userName || "-"}
                        </td>
                        <td className="p-3 table-top-bottom-border">
                          {item.userPhoneNumber || "-"}
                        </td>
                        <td className="p-3 table-top-bottom-border">
                          {item.paymentCreatedAt
                            ? formatDateTime(
                                item.paymentCreatedAt,
                                "DD/MM/YY hh:mm A"
                              )
                            : "-"}
                        </td>
                        <td className="p-3 table-top-bottom-border">
                          {item.bookingDate
                            ? formatDateTime(
                                item.bookingDate.split("T")[0] +
                                  "T" +
                                  item?.bookingTime,
                                "DD/MM/YY hh:mm A"
                              )
                            : "-"}
                        </td>
                        <td className="p-3 table-top-bottom-border table-right-border-radius">
                          {item.venuePaymentLog === 2 ||
                          item.venuePaymentLog === 4 ||
                          item.venuePaymentLog === 10
                            ? "yes"
                            : "no"}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr className="heading-color">
                      <td>No Data Found!</td>
                    </tr>
                  )}
                </tbody>
              </table>
            )} */}

            {toogleTabs === 3 && (
              <><label className="venue-listing-labels">
                <strong>Total Users </strong> :{" "}
                {response.totalCount}
              </label><table className="admin-stats-table-spacing px-0">
                  <tbody>
                    <tr className="admin-stats-header">
                      <th className="p-3 table-left-border-radius text-nowrap">
                        Name
                        <img
                          src="/images/arrows-down-up.svg"
                          alt=""
                          className="cursor-pointer ms-2"
                          onClick={() => handleSort("firstname")} />
                      </th>
                      <th className="p-3 text-nowrap">
                        City
                        <img
                          src="/images/arrows-down-up.svg"
                          alt=""
                          className="cursor-pointer ms-2"
                          onClick={() => handleSort("cityname")} />
                      </th>

                      <th className="p-3 text-center">Phone No.</th>
                      <th className="p-3 text-nowrap text-center">
                        Created At
                        <img
                          src="/images/arrows-down-up.svg"
                          alt=""
                          className="cursor-pointer ms-2"
                          onClick={() => handleSort("createdat")} />
                      </th>
                      <th className="p-3 text-nowrap text-center">
                        Booking
                        <img
                          src="/images/arrows-down-up.svg"
                          alt=""
                          className="cursor-pointer ms-2"
                          onClick={() => handleSort("bookingcount")} />
                      </th>
                      <th className="p-3 text-nowrap table-right-border-radius text-center">
                        Package
                        {/* <img
  src="/images/arrows-down-up.svg"
  alt=""
  className="cursor-pointer ms-2"
  onClick={() => handleSort("packagename")}
/> */}
                      </th>
                    </tr>
                    {response?.listingData?.length !== 0 ? (
                      response?.listingData?.map((item, index) => (
                        <tr key={index}>
                          <td className="p-3 table-top-bottom-border table-left-border-radius">
                            {item.firstName || "-"}
                          </td>
                          <td className="p-3 table-top-bottom-border ">
                            {item.cityName || "-"}
                          </td>

                          <td className="p-3 table-top-bottom-border text-center">
                            {item.phoneNumber || "-"}
                          </td>
                          <td className="p-3 table-top-bottom-border text-center">
                            {item.createdAt
                              ? formatDateTime(item.createdAt, "DD/MM/YY hh:mm A")
                              : "-"}
                          </td>
                          <td className="p-3 table-top-bottom-border text-center">
                            {item.bookingCount}
                          </td>
                          <td className="p-3 table-top-bottom-border text-center table-right-border-radius">
                            {item?.packageName?.length > 20
                              ? `${item.packageName.slice(0, 20)}...`
                              : item.packageName || "-"}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr className="heading-color">
                        <td>No Data Found!</td>
                      </tr>
                    )}
                  </tbody>
                </table></>
            )}
          </>
        )}
        {!loader ? (
          <div className="row my-4">
            <div className="col-6 offset-3 d-flex justify-content-center align-items-center gap-3">
              <select
                value={itemsPerPage}
                onChange={(e) => {
                  setItemsPerPage(parseInt(e.target.value, 10));
                  setCurrentPage(1);
                }}
                className="rounded border p-1"
                style={{ border: "1px solid #F1F1F1" }}
              >
                {[10, 20, 50, 100].map((size) => (
                  <option key={size} value={size} className="fs-6">
                    {size}
                  </option>
                ))}
              </select>
              <ResponsivePaginationComponent
                previousLabel={
                  <img src="/images/First.svg" alt="" height={24} width={24} />
                }
                nextLabel={
                  <img src="/images/Last.svg" alt="" height={24} width={24} />
                }
                current={currentPage}
                total={totalPage}
                onPageChange={handlePageChange}
                extraClassName="justify-content-center"
              />
            </div>
          </div>
        ) : null}
      </div>
    </React.Fragment>
  );
}
